import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import type { GraphqlClientSource } from "@ark/shared";

import { getInventoryListMinimalQueryDocument, getInventoryListTableQueryDocument } from "./inventory.gql";
import { useInventoriesQuery } from "./use-inventories-query";

export interface UseGetInventoryListProps {
  workspaceId: string;
  enabled?: boolean;
  source?: GraphqlClientSource;
}

export const useGetInventoryList = ({ workspaceId, enabled = true, source = "other" }: UseGetInventoryListProps) => {
  return useInventoriesQuery({
    workspaceId,
    queryKey: queryKeys.inventories.list(workspaceId, true),
    queryFn: async () => {
      if (!workspaceId) {
        throw new Error("Workspace ID is required");
      }
      const client = createOperationClient("GetInventoryListMinimal", false, { source });
      const response = await client.request(getInventoryListMinimalQueryDocument, { input: { workspaceId } });
      return response.inventoryList;
    },
    enabled: enabled && !!workspaceId,
  });
};

export const useGetInventoryTableList = ({
  workspaceId,
  enabled = true,
  source = "inventory-table",
}: UseGetInventoryListProps) => {
  return useInventoriesQuery({
    workspaceId,
    queryKey: queryKeys.inventories.list(workspaceId, false),
    queryFn: async () => {
      if (!workspaceId) {
        throw new Error("Workspace ID is required");
      }
      const client = createOperationClient("GetInventoryListTable", false, { source });
      const response = await client.request(getInventoryListTableQueryDocument, { input: { workspaceId } });
      return response.inventoryList;
    },
    enabled: enabled && !!workspaceId,
  });
};
